import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"cloudy-night-rain"},"children":[{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M15.512 11.3215C15.4871 11.3215 15.4622 11.3217 15.4374 11.3221C15.0832 9.28766 13.5035 7.65335 11.4542 7.14708C11.0235 7.04069 10.5721 6.98412 10.107 6.98412C10.0811 6.98412 10.0552 6.98429 10.0293 6.98464C10.2676 4.33646 12.3813 2.22889 15.0322 2C15.0185 2.15813 15.0116 2.31817 15.0116 2.47984C15.0116 5.52023 17.4763 7.98495 20.5167 7.98495C20.6783 7.98495 20.8384 7.97798 20.9965 7.96433C20.8388 9.79082 19.7892 11.3623 18.2854 12.241C18.1188 12.1154 17.9428 12.0009 17.7586 11.8987C17.0973 11.5315 16.3301 11.3215 15.512 11.3215Z"}},{"tag":"g","attrs":{"id":"stroke2"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M15.512 11.3215C15.4871 11.3215 15.4622 11.3217 15.4374 11.3221C15.0832 9.28766 13.5035 7.65335 11.4542 7.14708C11.0235 7.04069 10.5721 6.98412 10.107 6.98412C10.0811 6.98412 10.0552 6.98429 10.0293 6.98464C10.2676 4.33646 12.3813 2.22889 15.0322 2C15.0185 2.15813 15.0116 2.31817 15.0116 2.47984C15.0116 5.52023 17.4763 7.98495 20.5167 7.98495C20.6783 7.98495 20.8384 7.97798 20.9965 7.96433C20.8388 9.79082 19.7892 11.3623 18.2854 12.241C18.1188 12.1154 17.9428 12.0009 17.7586 11.8987C17.0973 11.5315 16.3301 11.3215 15.512 11.3215Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M12.9961 14.9766H13V14.9805H12.9961V14.9766Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M13 19.9766H13.0039V19.9805H13V19.9766Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M8 16.9766H8.00391V16.9805H8V16.9766Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M8 21.9766H8.00391V21.9805H8V21.9766Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M4.00186 19.6358C2.81538 19.068 2 17.889 2 16.5266C2 14.8784 3.19334 13.4986 4.79338 13.1447C4.7337 12.8349 4.70251 12.5156 4.70251 12.1892C4.70251 9.31466 7.12241 6.98438 10.1075 6.98438C10.5726 6.98438 11.024 7.04095 11.4547 7.14734C13.504 7.65361 15.0837 9.28792 15.4379 11.3223C15.4627 11.3219 15.4876 11.3217 15.5125 11.3217C16.3307 11.3217 17.0978 11.5318 17.7591 11.8989C19.1084 12.6481 20.0167 14.0515 20.0167 15.6591C20.0167 17.4379 18.9048 18.9666 17.3137 19.6358","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const CloudyNightRain = Vue.extend<IconProps>({
  name: 'CloudyNightRainIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'cloudy-night-rain',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default CloudyNightRain;
